export default "__VITE_ASSET__b037e04c__"